// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "week-3KU_8";
var _3 = "day-3qW2S";
export { _1 as "__esModule", _2 as "week", _3 as "day" }
export default { "__esModule": _1, "week": _2, "day": _3 }
